<template>

  <div class="root-box" v-loading="loading">
    <el-table :data="rows" :max-height="tableHeight" stripe class="no-hover" :row-class-name="rowClassName">
      <el-table-column label="司机编号" prop="driverNo" width="120"></el-table-column>
      <el-table-column label="积分" width="100">
        <template slot-scope="scope">
          {{ scope.row.routePoints == null ? 0 : scope.row.routePoints }}
        </template>
      </el-table-column>

      <el-table-column label="积分日期" prop="pointDate" width="120"></el-table-column>
      <el-table-column label="到达时间" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.arriveTime | dateFormat("yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
    </el-table>

  </div>

</template>



<script>

export default {

  props: {

    rows: {

      type: Array,

      default: () => []

    },

    viewDate: {

      type: String,

      default: ""

    },

    tableHeight: {

      type: Number,

      default: 480

    },

    loading: {

      type: Boolean,

      default: false

    }

  },

  methods: {

    rowClassName({ row }) {

      if (!this.viewDate) {

        return "";

      }

      const pointDate = this.normalizeDate(row.pointDate);

      if (!pointDate || pointDate === this.viewDate) {

        return "";

      }

      return "point-date-mismatch";

    },

    normalizeDate(val) {

      if (!val) {

        return "";

      }

      if (typeof val === "string") {

        return val.slice(0, 10);

      }

      return String(val);

    }

  }

};

</script>



<style lang="less" scoped>
::v-deep .point-date-mismatch {

  background-color: #fdf6ec !important;



  td {

    background-color: #fdf6ec !important;

  }

}
</style>
